import { useMonitor } from '../use-monitor';

export function useMonitorApproveIssueLoad() {
  return useMonitor('approve-issue-load');
}
